export default __webpack_public_path__ + "static/media/Tibbo Systems.20da72c8.png";